import React, { useState } from 'react';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 w-full z-50 bg-white/95 backdrop-blur-md shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <img src="/images/logo-final.png" alt="AWA Logo" className="h-16 w-auto" />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex gap-8">
            <button
              onClick={() => scrollToSection('features')}
              className="text-awa-gray hover:text-awa-green transition-colors font-medium"
            >
              المميزات
            </button>
            <button
              onClick={() => scrollToSection('properties')}
              className="text-awa-gray hover:text-awa-green transition-colors font-medium"
            >
              العقارات
            </button>
            <button
              onClick={() => scrollToSection('screenshots')}
              className="text-awa-gray hover:text-awa-green transition-colors font-medium"
            >
              التطبيق
            </button>
            <button
              onClick={() => scrollToSection('download')}
              className="text-awa-gray hover:text-awa-green transition-colors font-medium"
            >
              التحميل
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-awa-gray hover:text-awa-green transition-colors font-medium"
            >
              تواصل معنا
            </button>
          </nav>

          {/* Download Button */}
          <button
            onClick={() => scrollToSection('download')}
            className="hidden md:block gradient-bg text-white px-6 py-3 rounded-full font-semibold hover:opacity-90 transition-opacity"
          >
            حمّل التطبيق
          </button>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-awa-gray p-2"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100">
            <nav className="flex flex-col gap-4">
              <button
                onClick={() => scrollToSection('features')}
                className="text-awa-gray hover:text-awa-green transition-colors font-medium text-right px-4 py-2"
              >
                المميزات
              </button>
              <button
                onClick={() => scrollToSection('properties')}
                className="text-awa-gray hover:text-awa-green transition-colors font-medium text-right px-4 py-2"
              >
                العقارات
              </button>
              <button
                onClick={() => scrollToSection('screenshots')}
                className="text-awa-gray hover:text-awa-green transition-colors font-medium text-right px-4 py-2"
              >
                التطبيق
              </button>
              <button
                onClick={() => scrollToSection('download')}
                className="text-awa-gray hover:text-awa-green transition-colors font-medium text-right px-4 py-2"
              >
                التحميل
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-awa-gray hover:text-awa-green transition-colors font-medium text-right px-4 py-2"
              >
                تواصل معنا
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
